<template>
    <div>
        <div class="transaction-mobile-sec">
            <ul class="nav nav-tabs border-0" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="pills-deposit-tab" data-bs-toggle="pill"
                    data-bs-target="#pills-deposit" type="button" role="tab" aria-controls="pills-deposit"
                    aria-selected="true">Deposit</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="pills-withdrawal-tab" data-bs-toggle="pill"
                    data-bs-target="#pills-withdrawal" type="button" role="tab" aria-controls="pills-withdrawal"
                    aria-selected="false">Withdrawal</button>
                </li>
            </ul>
        </div>
        <div class="tab-content trasactions-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="pills-deposit" role="tabpanel" aria-labelledby="pills-deposit-tab">
                <template  v-for="(item, index) in walletHistoryData" :key="index">
                    <div class="transactions-m-item" v-if="item.request_type_id == 2">
                        <router-link :to="{ name: 'TransactionDetails', params: { id: item.id } }" class="transactions-container-information-item">
                            <div class="transactionsInformation">
                                <div class="transactionsInformation-img status successfull statusSuccessful">
                                    <img src="@/assets/images/IconSuccessful.svg" alt="">
                                </div> 
                                <div class="transactionsInformation-data">
                                    <div class="transactionsInformation-data__id">#txn{{ item.id }}</div>
                                    <div class="transactionsInformation-data__dateTime">{{ $dateTime.sportItemDate(item.created_at, 'MMM DD, YYYY, HH:mm:ss')}}</div>
                                </div> 
                                <div class="transactionsInformation-amount">₹ {{ item.bank_amount }}</div>
                                <div class="transactionsInformation-arrow">
                                    <img src="@/assets/images/IconArrow.svg" alt="">
                                </div>
                            </div>
                        </router-link>
                    </div>
                </template>
                <div v-if="filteredDepositHistory?.length === 0" class="no-records">
                    <NoDataFound/>
                </div>
            </div>
            <div class="tab-pane fade" id="pills-withdrawal" role="tabpanel" aria-labelledby="pills-withdrawal-tab">
                <template  v-for="(item, index) in walletHistoryData" :key="index">
                    <div class="transactions-m-item" v-if="item.request_type_id == 3">
                        <router-link :to="{ name: 'TransactionDetails', params: { id: item.id } }" class="transactions-container-information-item">
                            <div class="transactionsInformation">
                                <div class="transactionsInformation-img status successfull statusSuccessful">
                                    <img src="@/assets/images/IconSuccessful.svg" alt="">
                                </div> 
                                <div class="transactionsInformation-data">
                                    <div class="transactionsInformation-data__id">#txn{{ item.id }}</div>
                                    <div class="transactionsInformation-data__dateTime">{{ $dateTime.sportItemDate(item.created_at, 'MMM DD, YYYY, HH:mm:ss')}}</div>
                                </div> 
                                <div class="transactionsInformation-amount">₹ {{ item.bank_amount }}</div>
                                <div class="transactionsInformation-arrow">
                                    <img src="@/assets/images/IconArrow.svg" alt="">
                                </div>
                            </div>
                        </router-link>
                    </div>
                </template>
                <div v-if="filteredWithdrwalHistory?.length === 0" class="no-records">
                    <NoDataFound/>
                </div>
            </div>
        </div>

        <div class="transaction-bottom-pagination pb-2">
            <div class="show-entree" v-if="walletHistoryData?.length > 0">
                <label>{{$t('show','Show')}}</label>
                    <select v-model="pageEntries" @change="selectEntries()" class="form-select">
                        <option selected :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </select>
                <label>{{$t('entries','Entries')}}</label>
            </div>

            <div class="pagination-main mobile-view1" v-if="totalPage > 1">
                <ul class="pagination">
                    <li class="page-item" :class="{ disabled: pageNo === 1 }" @click="changePage(pageNo - 1)">
                        <a class="page-link">{{$t('previous','Previous')}}</a>
                    </li>
                    <li v-for="page in totalPage" :key="page" class="page-item" :class="{ active: page === pageNo }" @click="changePage(page)">
                        <a class="page-link">{{ page }}</a>
                    </li>
                    <li class="page-item" :class="{ disabled: pageNo === totalPage }" @click="changePage(pageNo + 1)">
                        <a class="page-link">{{$t('next','Next')}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import NoDataFound from '@/shared/components/no-data/NoDataFound.vue';

export default {
    name: 'Wallet History',
    data(){
        return{
            walletHistoryData: null,
            profitLossData: null,
            pageNo: 1,
            totalPage: 0,
            pageEntries: 10,
        }
    },
    components: { 
        NoDataFound
    },
    computed: {
        filteredDepositHistory() {
            return this.walletHistoryData?.filter(item => item.request_type_id === 2);
        },
        filteredWithdrwalHistory() {
            return this.walletHistoryData?.filter(item => item.request_type_id === 3);
        },
    },
    created(){
        this.getWalletHistory()
    },
    methods:{
        selectEntries() {
            this.pageNo = 1;
            this.getWalletHistory();
        },
        changePage(page) {
            if (page > 0 && page <= this.totalPage) {
                this.pageNo = page;
                this.getWalletHistory();
            }
        },
        getWalletHistory() {
            const params = {
                page: this.pageNo,
                perPage: this.pageEntries,
            };
            this.$store.dispatch('setGlobalLoader', true);
            this.$apiCall('get', 'GET_WALLET_HISTORY', {}, 'user', params).then(response => {
                this.$store.dispatch('setGlobalLoader', false);
                this.totalPage = 0;
                if (response?.status == 200) {
                    if (response?.data?.status == 0) {
                        this.$errorToast(response?.data?.debug[0]);
                    }
                    else {
                        const serviceData = response?.data?.data;
                        this.walletHistoryData = serviceData?.data || null;
                        this.totalPage = serviceData?.last_page || 0;
                        this.profitLossData = response.data.profitLoss;
                    }
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },

    }
}
</script>